import { NgModule } from '@angular/core';
import { Routes, RouterModule } from "@angular/router";
import { MessageSentCountComponent } from './CommunicationReports/message-sent-count/message-sent-count.component';
import { MessageStatusSummaryComponent } from './CommunicationReports/message-status-summary/message-status-summary.component';
import { DocumentCountComponent } from './DocumentRepositoryReport/document-count/document-count.component';
import { DocumentSummaryReportComponent } from './DocumentRepositoryReport/document-summary-report.component';
import { FlexReportComponent } from './flex-report/flex-report.component';
import { ScheduleDocumentReportsComponent } from './ScheduleDocumentReports/schedule-document-reports/schedule-document-reports.component';
import { ProductivityReportComponent } from './productivity-report/productivity-report/productivity-report.component';
import { ProjectDashboardComponent } from './project-dashboard/project-dashboard.component';
import { ErmReportsComponent } from './ScheduleDocumentReports/erm-reports/erm-reports.component';
import { ProjectProgressDashboardComponent } from './project-dashboard/project-progress-dashboard/project-progress-dashboard.component';
import { DrawingDashboardComponent } from './drawing-dashboard/drawing-dashboard.component';
import { StageWiseDashboardComponent } from './project-dashboard/stage-wise-dashboard/stage-wise-dashboard.component';
import { DocumentwiseProductivityComponent } from './productivity-report/documentwise-productivity/documentwise-productivity.component';
import { FinalDrawingComponent } from './final-drawing/final-drawing.component';
import { FlexManhourComponent } from './flex-report/flex-manhour/flex-manhour.component';
import { PendingDrawingStatusComponent } from './pending-drawing-status/pending-drawing-status.component';
import { QpapConsolidationReportComponent } from './qpap-consolidation-report/qpap-consolidation-report.component';
import { SCurveComponent } from './s-curve/s-curve.component';
import { CommunicationProtocolComponent } from './Communication-Protocol/Communication-Protocol.component';
import { DrawingsAdherenceComponent } from './Drawings_Schedule_Adherence_report/Drawings_Adherence_report.component';
import { DCIStatusSummaryReportComponent } from './dci-status-summary-report/dci-status-summary-report.component';
import { CCNSummaryReportComponent } from './ccn-summary-report/ccn-summary-report.component';

export const ReportRoutes: Routes = [
  {
    path: 'scurve',
    component: SCurveComponent,
    data: { title: 'Schedule Document S-Curve Chart', isProjectCodeRequired: true }
  },
  {
    path: 'flex',
    component: FlexReportComponent,
    data: { title: 'Flex Report', isProjectCodeRequired: true }
  },
  {
    path: 'documentsummary',
    component: DocumentSummaryReportComponent,
    data: { title: 'Document Summary Report', isProjectCodeRequired: true }
  },
  {
    path: 'documentcount',
    component: DocumentCountComponent,
    data: { title: 'Document Count Report', isProjectCodeRequired: true }
  },
  {
    path: 'messagestatussummary',
    component: MessageStatusSummaryComponent,
    data: { title: 'Message Status Summary Report', isProjectCodeRequired: true }
  },
  {
    path: 'messagesentcount',
    component: MessageSentCountComponent,
    data: { title: 'Message Count Report', isProjectCodeRequired: true }
  },
  {
    path: 'scheduledocument',
    component: ScheduleDocumentReportsComponent,
    data: { title: 'Schedule Document Reports', isProjectCodeRequired: true }
  },
  {
    path: 'productivity',
    component: ProductivityReportComponent,
    data: { title: 'Productivity Reports', isProjectCodeRequired: true }
  },
  {
    path: 'projectdashboard',
    component: ProjectDashboardComponent,
    data: { title: 'Project Dashboard', isProjectCodeRequired: true }
  },
  {
    path: 'projectprogressdashboard',
    component: ProjectProgressDashboardComponent,
    data: { title: 'Project Progress Dashboard', isProjectCodeRequired: true }
  },
  {
    path: 'stagewisedashboard',
    component: StageWiseDashboardComponent,
    data: { title: 'Stage Wise Dashboard', isProjectCodeRequired: true }
  },
  {
    path: 'drawingdashboard',
    component: DrawingDashboardComponent,
    data: { title: 'Drawing Dashboard', isProjectCodeRequired: false }
  },
  {
    path: 'erm',
    component: ErmReportsComponent,
    data: { title: 'ERM Report', isProjectCodeRequired: true }
  },
  {
    path: 'documentwiseproductivity',
    component: DocumentwiseProductivityComponent,
    data: { title: 'Documentwise Productivity', isProjectCodeRequired: true }
  },
  {
    path: 'finalDrawing',
    component: FinalDrawingComponent,
    data: { title: 'Final drawing', isProjectCodeRequired: true }
  },

  {
    path: 'flexmanhour',
    component: FlexManhourComponent,
    data: { title: 'Flex Man Hours Report', isProjectCodeRequired: true }
  },
  {
    path: 'pendingdrawingstatus',
    component: PendingDrawingStatusComponent,
    data: { title: 'Pending drawing Status', isProjectCodeRequired: true }
  },
  {
    path: 'qpapconsolidation',
    component: QpapConsolidationReportComponent,
    data: { title: 'QPAP Consolidation Report', isProjectCodeRequired: true }
  },
  {
    path: 'CommunicationProtocol',
    component: CommunicationProtocolComponent,
    data: { title: 'Communication Protocol', isProjectCodeRequired: true }
  },
  {
    path: 'dcistatussummary',
    component: DCIStatusSummaryReportComponent,
    data: { title: 'DCI Status Summary Report', isProjectCodeRequired: true }
  },
  {
    path: 'DrawingsAdherenceReport',
    component: DrawingsAdherenceComponent,
    data: { title: 'Drawings Schedule Adherence report', isProjectCodeRequired: true }
  },
  {
    path: 'CCNSummaryReport',
    component: CCNSummaryReportComponent,
    data: { title: 'CCN Summary Report', isProjectCodeRequired: true }
  }

];

@NgModule({
  imports: [RouterModule.forRoot(ReportRoutes)],
})

export class AppRoutingModule { }
